import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import ReactHtmlParser from 'react-html-parser'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { WithStyles, Theme, createStyles, withStyles, Grid, Typography, Chip, Paper, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Icon, TableHead, Table, TableRow, TableCell, TableBody, CircularProgress, Divider } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { Parallax } from 'react-parallax'
import autobind from 'autobind-decorator'
import { IProduct } from 'src/type/product'
import { getProductByType } from 'src/core/redux/action/productsAction'
import Btn from 'src/shared/Btn/Btn'
import { Page } from 'src/shared/RcPage'
import { config } from 'src/conf/config'
import * as moment from 'moment-timezone'
import Alert from 'src/shared/Alert/Alert'
import PcDialog from 'src/shared/Dialog/PcDialog'
import { UtilsAction } from 'src/core/redux/action/utilsAction'
import { getFileExtension, replaceDetteWithTaux } from 'src/shared/utils/helpers'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import {sortBy} from 'lodash'

const headerHeight = 180;

const styles = (t: Theme) => createStyles({
    root: {
        height: 'calc(100vh - 48px)' // 48px is a height of header
    },
    headerWpr: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: `${headerHeight}px`,
        padding: t.spacing.unit * 2,
        marginBottom: t.spacing.unit * 6,
        zIndex: 99,
    },
    contentWpr: {
        marginTop: `-${t.spacing.unit * 3}px`,
        [t.breakpoints.down('xs')]: {
            marginBottom: '50px'
        },
    },
    headerActions: {
        textAlign: 'center'
    },
    productName: {
        color: t.palette.common.white,
    },
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    titleExpand: {
        display: 'flex',
        alignItems: 'center'
    },
    expansionPnl: {
        boxShadow: 'none',
        '&:before': {
          display: 'none'
        },
    },
    xsScroll: {
        flexDirection: 'column',
        [t.breakpoints.down('sm')]: {
          overflow: 'auto'
        },
    },
    btnCotation:{
        cursor: 'pointer',
        [t.breakpoints.down('xs')]: {
          zIndex: 9999,
          position: 'fixed',
          top: 'auto',
          bottom: 0,
          left: 0,
          width: '100%'
        },
    }
})

interface IProps extends WithI18n, 
  WithStyles<typeof styles>,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

const format = 'hh:mm:ss'
const htmlParser = (text: string) => (ReactHtmlParser(text))

interface IState {
    modalOpen: boolean;
}

class Product extends React.Component<IProps, IState> {
  state = {
    modalOpen: false
  }
  

  render() {
    const {t, classes, product} = this.props
    return (
        <div className={classes.root}>
            {product &&
            <>
                <HelmetMeta title={product.name}/>

                <Parallax
                    bgImage={product.image_cover_url}
                    bgImageAlt="Arkea banner cover"
                    strength={300}
                >
                    <div className={classes.headerWpr} id="header">
                        <div>
                            <Typography variant="h4" className={classes.productName} gutterBottom>{product.name}</Typography>
                            {this.categoriesRendering(product as IProduct)}
                        </div>
                        <div className={classes.headerActions}>
                            <Btn
                                color='primary'
                                icon='record_voice_over'
                                variant='contained'
                                className={classes.btnCotation}
                                id="btn-cotation"
                                onClick={this.requestCotation}
                            >
                                {t.ask_cotation}
                            </Btn>
                        </div>
                    </div>
                </Parallax>
                <Page className={classes.contentWpr}>
                    <Paper>
                        {!moment(moment(),format).isBetween(moment('09:00:00', format).tz('Europe/Paris'), moment('18:00:00', format).tz('Europe/Paris')) &&
                            <Grid item xs={12} style={{padding: '16px'}}>
                                <Alert type="info">{t.ProductDetail_alert_cotation}</Alert>
                            </Grid>
                        }
                        
                        <Grid container>
                            <Grid item xs={12}>
                                <ExpansionPanel defaultExpanded={false} className={classes.expansionPnl}>
                                    <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
                                        <Typography variant="subtitle2" className={`${classes.titleExpand} text-uppercase`}>
                                            <Icon style={{marginRight: '5px'}}>attachment</Icon>
                                            {t.ProductDetail_first_tab_lbl}
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails className={classes.xsScroll}> 
                                        <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t.name}</TableCell>
                                                        <TableCell>{t.downloading}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {product.documents.length > 0 === true &&
                                                        <>
                                                            {sortBy(product.documents, ['name']).map(d => {
                                                                return(
                                                                    <TableRow key={`doc-row-${d.id}`}>
                                                                        <TableCell>{d.name}</TableCell>
                                                                        <TableCell>
                                                                            <img
                                                                                src={config.baseUrl + "/assets/images/file-type/" + getFileExtension(d.name) + ".png"}
                                                                                className="img-responsive"
                                                                                alt="Extension"
                                                                                style={{cursor: 'pointer'}}
                                                                                onClick={this.handleDownload(d.permalink)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })}
                                                        </>
                                                    }
                                                    {product.documents.length > 0 === false &&
                                                        <TableRow>
                                                            <TableCell style={{textAlign: 'center'}} colSpan={2}>{t.noFile}</TableCell>
                                                        </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <ExpansionPanel defaultExpanded={false} className={classes.expansionPnl}>
                                    <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
                                        <Typography variant="subtitle2" className={`${classes.titleExpand} text-uppercase`}>
                                            <Icon style={{marginRight: '5px'}}>description</Icon>
                                            {t.ProductDetail_second_tab_lbl}
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails className={classes.xsScroll}> 
                                        {htmlParser(product.description)}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                    <ExpansionPanel defaultExpanded={false} className={classes.expansionPnl}>
                                        <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
                                            <Typography variant="subtitle2" className={`${classes.titleExpand} text-uppercase`}>
                                                <Icon style={{marginRight: '5px'}}>info</Icon>
                                                {t.ProductDetail_third_tab_lbl}
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className={classes.xsScroll}>
                                            {htmlParser(product.description_compliance)}
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                            </Grid>
                        </Grid>

                        <PcDialog
                            open={this.state.modalOpen}
                            maxWidth="md"
                            fullWidth={true}
                            actions={
                                <Btn
                                    color='primary'
                                    onClick={this.toggleModalWarning}
                                >
                                    {t.cancel}
                                </Btn>
                            }
                        >
                            <Typography variant="body2">{t.cotation_request.cotation_request_warning}</Typography>
                        </PcDialog>
                    </Paper>
                </Page>
            </>
            }
            {!product &&
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px', width: '100%'}}>
                    <CircularProgress size={32}/>
                </div>
            }
        </div>
    )
  }

  @autobind
  private categoriesRendering(p: IProduct){
      const {mapName, classes} = this.props;
      return (
        <>
            {p.category_principale &&
                p.category_principale.split(",").map(c => 
                    mapName.get(c) !== undefined ? <Chip key={`category-principale-${c}`}  label={replaceDetteWithTaux(mapName.get(c))} className={classes.chip} /> : ''
                )
            }
            {p.category_produit &&
                p.category_produit.split(",").map(c => 
                    mapName.get(c) !== undefined ? <Chip key={`category-produit-${c}`}  label={mapName.get(c)} className={classes.chip} /> : ''
                )
            }
            {p.category_actu &&
                p.category_actu.split(",").map(c => 
                    mapName.get(c) !== undefined ? <Chip key={`category-actu-${c}`}  label={mapName.get(c)} className={classes.chip} /> : ''
                )
            }
        </>
      )
  }

  handleDownload = url => e => {
    window.open(url, "_blank")
  }

  componentDidMount(){
    const {promisesWithProgress, toastError, get, match, updateProductSelected} = this.props
    promisesWithProgress(
        get(match.params.productType).then(res => updateProductSelected(res)).catch(err => toastError(err.msg))
    )
  }

  @autobind
  private requestCotation(){
    const {enterprise, product} = this.props
    if((enterprise.is_mandataire && enterprise.is_mandataire === false) || (enterprise.habilitations && !enterprise.habilitations.includes(product.category_produit))){
        this.props.history.push({
            pathname: `/ptf/enterprise/${enterprise.id}/cotation-request/${product.product_type}`,
            state: { 
                duplicate: false,
                productSelected: product
            }
        })
    } else {
        this.toggleModalWarning()
    }
  }

  @autobind
  private toggleModalWarning(){
      this.setState({modalOpen: !this.state.modalOpen})
  }

}

const state2props = (state: RootState) => ({
    mapName: state.utils.mapCategories,
    mapProductType: state.utils.mapProductType,
    product: state.productDetail.entity,
    enterprise: state.accountInfo.enterpriseSelected
});

const dispatch2props = (dispatch: any) => ({
    updateProductSelected: (product: IProduct) => dispatch(UtilsAction.updateCotatonProductSelected(product)),
    get: (type: string) => dispatch(getProductByType(type)),
});

export default compose(
    withI18n,
    withRouter,
    withStyles(styles),
    withGlobalProgress,
    withToast,
    connect(state2props, dispatch2props),
)(Product)



// WEBPACK FOOTER //
// ./src/page/Consumer/Product/Product.tsx